var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AddDiscount',{key:_vm.updateDiscount,attrs:{"update":""},on:{"update":function($event){_vm.updateDiscount = !_vm.updateDiscount}}}),_c('Toast',{attrs:{"title":"بروزرسانی با موفقیت انجام شد","showToast":_vm.showToast}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }